// avatar スタンプの avatarSrc（配置時点の自己完結スナップショット）の許可条件を集約する単一ソース。
//
// 本機能は「選べる条件＝保存してよい条件＝描画してよい条件」を厳密一致させることを設計目的とする。
// サーバ ObjectSchema（永続化の権威）・クライアントの選択/配置判定・クリップボード検証・描画境界が
// すべてこの定義を参照することで、許可 MIME や上限長を変えても各所が一致したまま追従できる
// （正規表現リテラルや上限長を各経路へ手作業でコピーすると、一致が崩れた瞬間に経路間の不整合
// 「ツールバーに出るのに保存で 400」「保存できたのにクリップボードで弾かれる」へ逆戻りする）。

import { VIEWER_AVATAR_IMAGE_URL_MAX_LENGTH } from "../realtime/viewer";

/**
 * avatar スタンプの avatarSrc として許可する「安全なラスタ data:image/ base64 スナップショット」の正規表現。
 * data:image/svg+xml（onload を実行しうる）・data:text/html・リモート https 参照を弾くのに加え、
 * `;base64,` と実データ部分まで必須にして、`data:image/png;` や `data:image/png;foo` のような
 * 中身を伴わない / 自己完結でない文字列も拒否する（配置時点の自己完結スナップショットであることを担保）。
 */
export const AVATAR_SNAPSHOT_DATA_URL_PATTERN =
  /^data:image\/(jpeg|jpg|png|gif|webp);base64,(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/i;

/**
 * avatar スタンプの avatarSrc として保存・配置・表示してよい「自己完結スナップショット」か。
 * 安全なラスタ data:image/（jpeg/png/gif/webp）かつ viewer アバター上限以内の文字列のみ true。
 * 入力は外部由来の unknown も受け付け、型・長さ・形式をまとめて判定する。
 */
export function isAvatarSnapshotDataUrl(src: unknown): boolean {
  return (
    typeof src === "string" &&
    src.length <= VIEWER_AVATAR_IMAGE_URL_MAX_LENGTH &&
    AVATAR_SNAPSHOT_DATA_URL_PATTERN.test(src)
  );
}
